import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';
import numeral from 'numeral';
import cognitesdk from '@cognite/cognitesdk';

const LegendWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
  margin-right: 10px;
  background-color: rgb(245, 244, 245);
  margin-top: 5px;
`;

const LegendLeft = styled.div`
  width: 70%;
  padding: 10px;
`;

const LegendRight = styled.div`
  width: 30%;
  background: ${props => props.color};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: white;
  text-align: center;
`;

const LeftTitle = styled.p`
  font-size: 0.7rem;
  margin-bottom: 10px;
`;

const LeftDescription = styled.p`
  font-size: 1rem;
  margin-bottom: 0;
  color: black;
`;

const RightValue = styled.p`
  font-size: 1.2rem;
  margin: 0;
`;

const RightUnit = styled.p`
  margin: 0;
  font-size: 0.8rem;
`;

const RightTimestamp = styled.p`
  margin: 0;
  font-size: 0.7rem;
  margin-bottom: 5px;
`;

class TagView extends React.Component {
  static propTypes = {
    tagId: PropTypes.string.isRequired,
    description: PropTypes.string,
    color: PropTypes.string.isRequired,
    value: PropTypes.number,
    timestamp: PropTypes.number,
    onClick: PropTypes.func,
    updateIntervalMillis: PropTypes.number,
    unit: PropTypes.string,
  };

  static defaultProps = {
    timestamp: 0,
    description: '',
    value: undefined,
    onClick: () => {},
    updateIntervalMillis: 0,
    unit: '',
  };

  constructor(props) {
    super(props);
    this.state.value = props.value;
    this.state.timestamp = props.timestamp;
  }

  state = {};

  componentDidMount() {
    if (this.props.updateIntervalMillis > 0) {
      this.pollInterval = setInterval(
        this.fetchLatestValue,
        this.props.updateIntervalMillis
      );
      this.fetchLatestValue();
    }
  }

  componentWillUnmount() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
    }
  }

  fetchLatestValue = () => {
    cognitesdk
      .getLatestDataPoint({ tagId: this.props.tagId })
      .then(data => {
        this.setState({
          value: data.items[0].value,
          timestamp: data.items[0].timestamp,
        });
      })
      .catch(console.error);
  };

  render() {
    const { tagId, description, color, unit, onClick } = this.props;
    const value = this.state.value || this.props.value;
    const timestamp = this.state.timestamp || this.props.timestamp;
    return (
      <LegendWrapper onClick={onClick}>
        <LegendLeft>
          <LeftTitle>{tagId}</LeftTitle>
          <LeftDescription>{description}</LeftDescription>
        </LegendLeft>
        <LegendRight color={color}>
          <RightValue>
            {value !== undefined ? numeral(value).format('0[.]0[00]') : 0}
          </RightValue>
          <RightUnit>{unit}</RightUnit>
          <RightTimestamp>
            {moment(timestamp).format('MMM D, HH:mm:ss')}
          </RightTimestamp>
        </LegendRight>
      </LegendWrapper>
    );
  }
}

export default TagView;



// WEBPACK FOOTER //
// ./src/components/TagView/TagView.js